import React from "react";
import { FaStar, FaHome, FaUtensils } from "react-icons/fa";
import { formatPrice, formatParameterLabel } from "../utils/labTests";

const AddButton = ({ filled, inCart, onClick }) => (
  <button
    type="button"
    onClick={(e) => { e.stopPropagation(); onClick(); }}
    className={`px-4 py-2 rounded-lg text-sm font-semibold transition ${
      filled
        ? "bg-primary text-white hover:bg-primary-container"
        : "border-2 border-primary text-primary bg-surface-lowest hover:bg-primary-fixed/30"
    }`}
  >
    {inCart ? "Added" : "Add to Cart"}
  </button>
);

export const FeaturedLabCard = ({ item, inCart, onAddToCart, onCardClick, hideCart = false }) => (
  <article
    onClick={onCardClick}
    className="md:col-span-2 bg-surface-lowest rounded-xl border border-surface-container p-4 sm:p-6 shadow-sm cursor-pointer hover:shadow-md transition flex flex-col md:flex-row gap-4 sm:gap-6 min-w-0"
  >
    <div className="flex-1">
      <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary bg-primary-fixed/40 px-2 py-1 rounded-full mb-3">
        <FaStar size={10} /> Highly Recommended
      </span>
      <h3 className="text-lg sm:text-xl font-bold text-on-primary-fixed-var">{item.title}</h3>
      {item.description && (
        <p className="text-sm text-on-surface-variant mt-2 line-clamp-3">{item.description}</p>
      )}
      <div className="flex flex-wrap gap-3 mt-4 text-sm text-on-surface-variant">
        {item.parameterCount != null && <span>{formatParameterLabel(item.parameterCount)}</span>}
        {item.homeCollection && (
          <span className="flex items-center gap-1"><FaHome className="text-primary" /> Home Collection</span>
        )}
      </div>
    </div>
    <div className="md:w-48 flex flex-col items-end justify-between shrink-0">
      <div className="text-right">
        {item.originalPrice != null && item.originalPrice > item.price && (
          <p className="text-sm text-on-surface-variant line-through">{formatPrice(item.originalPrice)}</p>
        )}
        <p className="text-xl sm:text-2xl font-bold text-primary">{formatPrice(item.price)}</p>
        <p className="text-xs text-on-surface-variant">Covered by Wallet</p>
      </div>
      {!hideCart && <AddButton filled inCart={inCart} onClick={onAddToCart} />}
    </div>
  </article>
);

const LabCatalogCard = ({ item, inCart, onAddToCart, onCardClick, hideCart = false }) => (
  <article
    onClick={onCardClick}
    className="bg-surface-lowest rounded-xl border border-surface-container p-3 sm:p-4 shadow-sm cursor-pointer hover:shadow-md transition flex flex-col min-w-0"
  >
    <h3 className="font-bold text-sm sm:text-base text-on-primary-fixed-var truncate">{item.title}</h3>
    {item.category && (
      <p className="text-xs text-primary mt-1">{item.category}</p>
    )}
    {item.description && (
      <p className="text-sm text-on-surface-variant mt-2 line-clamp-2">{item.description}</p>
    )}
    <div className="flex flex-wrap gap-2 mt-3">
      {item.fastingRequired ? (
        <span className="text-xs px-2 py-0.5 rounded-full bg-surface-low text-on-surface-variant flex items-center gap-1">
          <FaUtensils size={10} /> Fasting Req.
        </span>
      ) : item.itemType !== "scan" ? (
        <span className="text-xs px-2 py-0.5 rounded-full bg-surface-low text-on-surface-variant">No Fasting</span>
      ) : null}
      {item.homeCollection && (
        <span className="text-xs px-2 py-0.5 rounded-full bg-surface-low text-on-surface-variant flex items-center gap-1">
          <FaHome size={10} /> Home Collection
        </span>
      )}
      {item.reportLabel && (
        <span className="text-xs px-2 py-0.5 rounded-full bg-surface-low text-on-surface-variant">
          Report in {item.reportLabel}
        </span>
      )}
      {item.parameterCount != null && item.parameterCount > 0 && (
        <span className="text-xs px-2 py-0.5 rounded-full bg-surface-low text-on-surface-variant">
          {formatParameterLabel(item.parameterCount)}
        </span>
      )}
    </div>
    {item.centres?.length > 0 && (
      <p className="text-xs text-on-surface-variant mt-3 line-clamp-2">
        {item.centres.join(", ")}
      </p>
    )}
    <div className="flex items-center justify-between mt-4 pt-4 border-t border-surface-container">
      <p className="text-base sm:text-lg font-bold text-on-primary-fixed-var">{formatPrice(item.price)}</p>
      {!hideCart && <AddButton filled={item.primaryAction?.style === "filled"} inCart={inCart} onClick={onAddToCart} />}
    </div>
  </article>
);

export const CategoryPromoCard = ({ name, count, onClick }) => (
  <article
    onClick={onClick}
    className="bg-primary-fixed/30 rounded-xl border border-primary-fixed-dim p-5 cursor-pointer hover:bg-primary-fixed/50 transition"
  >
    <p className="font-bold text-primary text-lg">{name}</p>
    <p className="text-sm text-on-surface-variant mt-1">Specialized packages for your wellness needs.</p>
    <p className="text-sm text-primary font-semibold mt-3">View {count} Packages →</p>
  </article>
);

export default LabCatalogCard;
